<template>
  <div>
    <b-skeleton-wrapper :loading="loading">
      <template #loading>
        <Card>
          <b-skeleton width="85%"></b-skeleton>
          <b-skeleton width="55%"></b-skeleton>
          <b-skeleton width="70%"></b-skeleton>
        </Card>
      </template>
      <Card>
        <template #header>
          <div class="w-100 d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              {{ item.name }}
              <div class="ml-3"
                   v-html="$customFunctions.getFormDraftStatus(item.isDraft)"></div>
            </div>
            <div v-if="
                item.isSystemTemplate === true && isTemplateManagePage === false
              ">
              <div class="btn btn-primary"
                   @click="copySystemTemplate">
                FORMU KULLAN
              </div>
            </div>
          </div>
        </template>
        <div class="row">
          <div class="col-12 col-lg-4"
               v-if="item.description">
            {{ item.description }}
          </div>
          <div class="col-12 mt-5 mt-md-0"
               :class="item.description?'col-lg-8':''">
            <div class="d-flex align-items-top justify-content-between">
              <div class="text-center px-5"
                   v-if="item.isSystemTemplate === false">
                <div class="font-size-sm mb-2">İş Birimi</div>
                <!-- <div
                  class="font-weight-bold"
                  v-html="
                    item.organizationBusinessUnitNames &&
                    item.organizationBusinessUnitNames.length > 0
                      ? item.organizationBusinessUnitNames.join('<br />')
                      : ''
                  "
                ></div> -->
                <div class="notAllowHeightTooMuch"
                     v-if="item.organizationBusinessUnitNames &&
                    item.organizationBusinessUnitNames.length > 0">
                  <div v-for="(_item, index) in item.organizationBusinessUnitNames"
                       :key="index"
                       class="mb-2 font-size-xs font-weight-bold">
                    {{'&bull; '+_item}}
                  </div>
                </div>
                <div v-else
                     class="font-size-xs font-weight-bold">
                  Tüm İş Birimleri
                </div>
              </div>
              <div class="text-center px-5"
                   v-if="item.isSystemTemplate === false">
                <div class="font-size-sm mb-2">Pozisyon</div>
                <div class="notAllowHeightTooMuch"
                     v-if="item.organizationPositionNames &&
                    item.organizationPositionNames.length > 0">
                  <div v-for="(_item, index) in item.organizationPositionNames"
                       :key="index"
                       class="mb-2 font-size-xs font-weight-bold">
                    {{'&bull; '+_item}}
                  </div>
                </div>
                <div v-else
                     class="font-size-xs font-weight-bold">
                  Tüm Pozisyonlar
                </div>
                <!-- <div
                  class="font-weight-bold"
                  v-html="
                    item.organizationPositionNames &&
                    item.organizationPositionNames.length > 0
                      ? item.organizationPositionNames.join('<br />')
                      : 'Tüm Pozisyonlar'
                  "
                ></div> -->
              </div>
              <div class="text-center ml-3 px-5">
                <div class="font-size-sm mb-2">Oluşturan</div>
                <div class=" font-size-xs font-weight-bold">
                  {{ item.createdUserName ?? '-' }}
                </div>
              </div>
              <div class="text-center ml-3 px-5">
                <div class="font-size-sm mb-2">Oluşturma</div>
                <div class=" font-size-xs font-weight-bold">
                  {{
                    $customFunctions.setMomentWithFormat(
                      item.creationTime,
                      'DD.MM.yyyy'
                    )
                  }}
                </div>
              </div>
              <div class="text-center ml-3 px-5">
                <div class="font-size-sm mb-2">Son Güncelleme</div>
                <div class=" font-size-xs font-weight-bold">
                  {{
                    $customFunctions.setMomentWithFormat(
                      item.updateTime,
                      'DD.MM.yyyy'
                    )
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Card>

      <Card class="mt-5"
            v-for="process in item.formProcessList"
            :key="process.id">
        <template #header>
          <div class="w-100 d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <span class="font-weight-normal mr-2">Süreç : </span>
              {{ process.name }}
            </div>
          </div>
        </template>

        <template>
          <div class="list mb-5"
               v-if="
              process.formActivityList && process.formActivityList.length > 0
            ">
            <div class="list-header py-4"
                 :style="
                item.isSystemTemplate === true
                  ? 'grid-template-columns: 3fr 3fr 2fr 2fr 2fr'
                  : 'grid-template-columns: 3fr 3fr 3fr'
              ">
              <div class="item text-dark font-weight-boldest d-flex align-items-center">
                Aktivite
                <!-- <i
                  class="flaticon-information ml-2 text-dark-50"
                  v-b-tooltip.hover="'Bilgi eklenecek.'"
                /> -->
              </div>
              <!-- <div class="item text-dark font-weight-boldest d-flex align-items-center"
                   v-if="item.isSystemTemplate === false">
                Aktivite Sorumlusu
              </div> -->
              <!-- <div class="item text-dark font-weight-boldest d-flex align-items-center">
                Aktivite Çıktısı
               
              </div> -->
              <!-- <div class="item text-dark font-weight-boldest d-flex align-items-center">
                Çıktı Miktarı
               
              </div> -->
              <div class="item text-dark font-weight-boldest d-flex align-items-center">
                Saat
                <!-- <i
                  class="flaticon-information ml-2 text-dark-50"
                  v-b-tooltip.hover="'Bilgi eklenecek.'"
                /> -->
              </div>
              <div class="item text-dark font-weight-boldest d-flex align-items-center">
                Dönem
                <!-- <i
                  class="flaticon-information ml-2 text-dark-50"
                  v-b-tooltip.hover="'Bilgi eklenecek.'"
                /> -->
              </div>
            </div>
            <div class="list-content border-gray"
                 v-for="formActivityItem in process.formActivityList"
                 :key="formActivityItem.id">
              <div class="item py-4"
                   :style="
                  item.isSystemTemplate === true
                    ? 'grid-template-columns: 3fr 3fr 2fr 2fr 2fr'
                    : 'grid-template-columns: 3fr 3fr 3fr'
                ">
                <div class="field text-dark font-weight-normal">
                  <span class="font-weight-bold">{{
                    formActivityItem.name
                  }}</span>
                </div>
                <!-- <div class="field text-dark font-weight-normal"
                     v-if="item.isSystemTemplate === false">
                  {{ formActivityItem.organizationName }}
                </div> 
             <div class="field text-dark font-weight-normal">
                  {{ formActivityItem.activityOutput }}
                </div> 
                <div>
                  <NumberInput placeholder="Adet"
                               formGroupClass="mb-0 mr-2"
                               :id="`${formActivityItem.id}_adet`" />
                </div> -->
                <div>
                  <NumberInput placeholder="Saat"
                               formGroupClass="mb-0 mr-2"
                               :id="`${formActivityItem.id}_saat`" />
                </div>
                <div>
                  <Select formGroupClass="mb-0 mr-2"
                          :id="`${formActivityItem.id}_donem`"
                          :options="[
                      {
                        value: 'Weekly',
                        text: $customFunctions.getPeriodName('Weekly'),
                      },
                      {
                        value: 'Monthly',
                        text: $customFunctions.getPeriodName('Monthly'),
                      },
                      {
                        value: 'Quarterly',
                        text: $customFunctions.getPeriodName('Quarterly'),
                      },
                      {
                        value: 'Yearly',
                        text: $customFunctions.getPeriodName('Yearly'),
                      },
                    ]" />
                </div>
              </div>
            </div>
          </div>
        </template>
      </Card>
    </b-skeleton-wrapper>
  </div>
</template>

<script>
export default {
  name: "PreviewView",
  props: {
    selectedItemId: String,
    isTemplateManagePage: {
      type: Boolean | String,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      item: "",
    };
  },
  created() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      if (this.selectedItem !== "" && this.selectedItemId !== undefined) {
        this.loading = true;
        this.item = "";
        this.$dbFunctions
          .get(`form/${this.selectedItemId}`)
          .then((res) => {
            if (res.success == true) {
              this.item = res.data;
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    copySystemTemplate() {
      this.$dbFunctions
        .insertOrUpdate(`form/copyTemplate`, "", {
          sourceFormId: this.selectedItemId,
        })
        .then((res) => {
          this.$dbFunctions.setResponse(this, res);
          setTimeout(() => {
            this.$router.push(`/formlar/${res.data}`);
          }, 500);
        })
        .catch((err) => {
          this.$dbFunctions.setResponse(this, err);
        })
        .finally(() => {});
    },
  },
};
</script>
